import type { ReactNode } from 'react';

export const SkeletonOffer = () => <article data-testid="SkeletonOffer" className="panel u-pa32 skeleton-screen" />;

export const listOfSkeletons = (size: number): ReactNode[] =>
    // biome-ignore lint/suspicious/noArrayIndexKey: index isn't useless here
    [...new Array(size).keys()].map((_, index) => <SkeletonOffer key={`skeletonOffer-${index}`} />);
